import * as React from 'react';
import { Question } from 'survey-core';
import { SurveyQuestionElementBase } from 'survey-react-ui';
import { Checkbox, FormControlLabel, styled, Typography } from '@material-ui/core';

export const TYPE = 'mui-checkbox';

export class MuiCheckboxModel extends Question {
  getType(): string {
    return TYPE;
  }

  get links() {
    return this.getPropertyValue('links');
  }
  set links(val) {
    this.setPropertyValue('links', val);
  }
}

const StyledFormControlLabel = styled(FormControlLabel)({
  alignItems: 'flex-start',
  '& .MuiTypography-root .MuiTypography-body2': {
    lineHeight: '1.25rem',
    letterSpacing: '0.015625em'
  }
});
const StyledCheckbox = styled(Checkbox)({
  marginTop: -10
});

export class MuiCheckbox extends SurveyQuestionElementBase {
  constructor(props: any) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  public get question() {
    return this.questionBase;
  }

  getLinks() {
    return this.question.links;
  }

  handleChange({ target: { checked } }: React.ChangeEvent<HTMLInputElement>) {
    this.question.value = checked;
  }

  protected renderElement(): JSX.Element | null {
    const { title, value = '' } = this.question;
    const links = this.getLinks();
    let titleReplaced = title;

    if (Array.isArray(links)) {
      links.forEach(({ text, href }, index) => {
        titleReplaced = titleReplaced.replace(
          `{${index}}`,
          `<a class="checkbox-link" target="_blank" href="${href}" rel="noopener noreferrer" tabindex='1'>${text}</a>`
        );
      });
    }

    return (
      <StyledFormControlLabel
        checked={value === true}
        onChange={this.handleChange}
        control={<StyledCheckbox color="primary" inputProps={{ tabIndex: 1 }} />}
        label={<Typography dangerouslySetInnerHTML={{ __html: titleReplaced }} variant="body2" />}
      />
    );
  }
}
